/**
 * Generates the XPath of a given HTML element.
 *
 * This function traverses the DOM tree from the specified element up to the root,
 * constructing an XPath that uniquely identifies the element within the document.
 *
 * @param element The HTML element for which to generate the XPath.
 * @returns The XPath string representing the element's location in the DOM.
 *          Returns an empty string if the provided element is null or undefined.
 */
export function getElementXPath(element) {
  // If the element doesn't exist, return an empty string
  if (!element) return '';

  // If this is the document root, return "/"
  if (element === document.documentElement) return '/';

  // Start building the XPath
  const paths = [];

  // Traverse up the DOM tree
  let currentElement = element;
  while (currentElement && currentElement.nodeType === Node.ELEMENT_NODE) {
    let pathComponent = '';
    const tagName = currentElement.nodeName.toLowerCase();

    // Add ID if available for more specific targeting
    if (currentElement.id) {
      pathComponent = `${tagName}[@id='${currentElement.id}']`;
    } else {
      // Get the index of this element among its siblings of the same tag
      let index = 0;
      let sibling = currentElement;
      while (sibling) {
        if (sibling.nodeName === currentElement.nodeName) {
          index++;
        }
        sibling = sibling.previousElementSibling;
      }

      // Construct the path component for this element
      pathComponent = index > 1 ? `${tagName}[${index}]` : tagName;
    }
    paths.unshift(pathComponent);

    // Move up to the parent
    currentElement = currentElement.parentElement;
  }

  // Join all parts with / to form the XPath
  return `/${paths.join('/')}`;
}